import React from 'react';

function Contact() {
  return (
    <div className="ScrollableContainer">
        <p className="defaultParagraph">A contact form is in progress for this page. I'm not too worried
        about email scrapers at the moment so feel free to contact me at <a href="mailto:jonathanmichael5150@gmail.com">jonathanmichael5150@gmail.com</a> until the form is complete.</p>
    </div>
  );
}

export default Contact;